"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Il = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1100 800", ...props },
    react_1.default.createElement("path", { fill: "#fff", d: "M0 0h1100v800H0z" }),
    react_1.default.createElement("path", { fill: "#0038b8", d: "M0 75h1100v125H0zm0 525h1100v125H0z" }),
    react_1.default.createElement("path", { fill: "none", stroke: "#0038b8", strokeWidth: 27.5, d: "M423.816 472.853h252.368L550 254.295zM550 545.705l126.184-218.558H423.816z" })));
exports.default = Il;
//# sourceMappingURL=Il.js.map